import React from 'react';
import './Header.css';
import logo from '../../../assets/img/logo.svg';
import bglayer1 from '../../../assets/img/bg-layer-1.svg';
import bglayer2 from '../../../assets/img/bg-layer-2.svg';
import bglayer3 from '../../../assets/img/bg-layer-3.svg';
import cloud1 from '../../../assets/img/cloud-1.svg';
import cloud2 from '../../../assets/img/cloud-2.svg';
import cloud3 from '../../../assets/img/cloud-3.svg';
import stars1 from '../../../assets/img/stars-1.svg';
import stars2 from '../../../assets/img/stars-2.svg';
import stars3 from '../../../assets/img/stars-3.svg';


const Landing = () => {

  React.useEffect(() => {
    const st1 = document.getElementById('st1');
    const st2 = document.getElementById('st2');
    const st3 = document.getElementById('st3');
    const bglayer2 = document.getElementById('bg-layer2');
    const bglayer3 = document.getElementById('bg-layer3');
    

    window.addEventListener('scroll', function () {
      let value = window.scrollY;
      st1.style.top = value * 0.5 + 'px';
      st2.style.top = value * 0.3 + 'px';
      st3.style.top = value * 0.1 + 'px';
      bglayer2.style.top = value * 0.2 + 'px';
      bglayer3.style.top = value * 0.5 + 'px';
    })
  });

  return (
    <>
      <section className="header">
        <img className="background animated_stars" id="st1" src={stars1} alt="stars1" />
        <img className="background animated_stars" id="st2" src={stars2} alt="stars2" />
        <img className="background animated_stars" id="st3" src={stars3} alt="stars3" />
        <img className="logo" src={logo} alt="logo" />
        <img className="background" src={bglayer3} alt="bg-layer3" id="bg-layer3"/>
        <img className="background cloud1" src={cloud1} alt="cloud1" />
        <img className="background cloud2" src={cloud2} alt="cloud2" />
        <img className="background cloud3" src={cloud3} alt="cloud3" />
        <img className="background" src={bglayer2} alt="bg-layer2" id="bg-layer2"/>
        <img className="background" src={bglayer1} alt="bg-layer1" />
      </section>
    </>
  );
}

export default Landing;
